var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandsReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90923 16.1437L1.24835 9.48286L6.44908 4.28213L9.03315 6.8662L9.72373 6.17561L5.63895 2.08141L0.607782 7.11256L1.77735 8.28213L0.917182 9.13286L-1.11035 7.0959L5.62228 0.363281L7.83025 2.57126L10.01 0.391548L16.831 7.21256L7.90923 16.1437ZM7.91648 14.4329L15.1034 7.21256L10.01 2.10968L8.69765 3.43141L11.4419 6.17561L9.03315 8.58433L6.44908 6.00026L2.96648 9.48286L3.66648 10.1829L6.28895 7.5604L7.00562 8.27706L4.38315 10.8995L5.09982 11.6162L7.72228 8.99373L8.42228 9.69373L5.79982 12.3162L6.48315 12.9995L9.10562 10.3771L9.82228 11.0937L7.19982 13.7162L7.91648 14.4329Z",
    fill: "#474F56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsReferral);
export default __webpack_public_path__ + "static/media/hands-referral.bd4b1c7bdc06e6f49b84d3774c50b719.svg";
export { ForwardRef as ReactComponent };